export default __webpack_public_path__ + "static/profileimage3-3881594591a306ae3078483eab42f045.png";